import React from 'react';
import { GlobalConfiguration } from '../../../models/GlobalConfiguration';
import StyledFieldDescription from '../../styles/StyledFieldDescription';
import { StyledInput } from '../../styles/StyledInputs';
import StyledSection from '../../styles/StyledSection';
import { StyledFieldRow, StyledHeading, StyledLabel } from '../../styles/styles';
import ConfigFieldLabel from './ConfigFieldLabel';
import { GLOBAL_CONFIG_FIELD_LABELS, MEDIA_CONTENT_FIELDS } from './globalConfigFieldConfig';

type MediaContentSectionProps = {
  config: GlobalConfiguration;
  dirtyFields: Set<string>;
  onChange: (field: string, value: unknown) => void;
};

export default function MediaContentSection({
  config,
  dirtyFields,
  onChange,
}: MediaContentSectionProps) {
  return (
    <StyledSection tone="tone1">
      <StyledHeading tone="tone1" headerVariant="heading2">
        Media and Content Configuration
      </StyledHeading>
      {MEDIA_CONTENT_FIELDS.map((fieldKey) => (
        <StyledFieldRow stacked sx={{ mb: 2 }} key={fieldKey}>
          <StyledLabel stacked>
            <ConfigFieldLabel
              fieldKey={fieldKey}
              label={GLOBAL_CONFIG_FIELD_LABELS[fieldKey]}
              dirtyFields={dirtyFields}
            />
          </StyledLabel>
          <StyledFieldDescription stacked>
            {GLOBAL_CONFIG_FIELD_LABELS[fieldKey]} configuration for bulk storage operations.
          </StyledFieldDescription>
          <StyledInput
            type="number"
            value={(config as unknown as Record<string, unknown>)[fieldKey] || ''}
            onChange={(e) => onChange(fieldKey, parseInt(e.target.value) || 0)}
            inputProps={{ min: 1, step: 1 }}
          />
        </StyledFieldRow>
      ))}

      <StyledFieldRow stacked sx={{ mb: 2 }} data-field="newsBlogSourceUrl">
        <StyledLabel stacked>
          <ConfigFieldLabel
            fieldKey="newsBlogSourceUrl"
            label={GLOBAL_CONFIG_FIELD_LABELS.newsBlogSourceUrl}
            dirtyFields={dirtyFields}
          />
        </StyledLabel>
        <StyledFieldDescription stacked>
          Blog listing page the mobile-app News section imports posts from. Admins scan and select
          posts on the News screen; this is the only site they can import from.
        </StyledFieldDescription>
        <StyledInput
          type="url"
          value={config.newsBlogSourceUrl ?? ''}
          onChange={(e) => onChange('newsBlogSourceUrl', e.target.value)}
          placeholder="https://www.fidescapital.com.au/blog/"
        />
      </StyledFieldRow>
    </StyledSection>
  );
}
